import { orderBy, sortBy } from 'lodash';
import { differenceInCalendarDays, parseISO } from 'date-fns';

import { OrderDirection } from '@constants';
import { IAvailableCandidate } from '@types';
import { rankingTierIndex, scoreOf, sinkingSortValue } from './candidate';

const sortValue = (
  candidate: IAvailableCandidate,
  key: string,
  direction: OrderDirection,
): string | number => {
  switch (key) {
    case 'name':
      return candidate.name.toLowerCase();
    case 'technicalRanking':
      return sinkingSortValue(
        rankingTierIndex(candidate.ranking?.technicalInterview),
        direction,
      );
    case 'softSkills':
      return sinkingSortValue(
        rankingTierIndex(candidate.ranking?.softSkills),
        direction,
      );
    case 'testTask':
      return sinkingSortValue(scoreOf(candidate.testTask), direction);
    default: {
      const { kind, date } = candidate.availability;

      return sinkingSortValue(
        kind === 'immediately'
          ? 0
          : kind === 'date'
            ? differenceInCalendarDays(parseISO(date ?? ''), new Date())
            : null,
        direction,
      );
    }
  }
};

export const sortAvailableCandidates = (
  candidates: IAvailableCandidate[],
  sort: { key: string; direction: OrderDirection },
) =>
  sort.key
    ? orderBy(
        candidates,
        (candidate) => sortValue(candidate, sort.key, sort.direction),
        [sort.direction],
      )
    : sortBy(candidates, ({ mark }) => mark !== 'favourite');
